import React from 'react';

import { useLocation } from 'react-router-dom';

import { useGlobal } from '../../contexts/Global/context';

import { ContractChange } from './ContractChange';
import getPathLabel from './getPathLabel';

import * as S from './styles';

function Breadcrumb() {
    const location = useLocation();
    const { dataActiveContract, useAllContracts } = useGlobal();

    const paths = location.pathname.split('/').filter((path) => path !== '');
    paths.unshift('Home');
    const lastPath = paths[paths.length - 1];
    const isHome = lastPath === 'Home';

    if (!getPathLabel(lastPath)) return <></>;

    return (
        <S.Container hasBorder={!isHome}>
            <S.BreadcrumbContainer>
                {paths && (
                    <>
                        <S.PagesList>
                            {paths.map((page, index) => (
                                <React.Fragment key={`breadcrumb-${page}`}>
                                    {index < paths.length - 1 && (
                                        <>
                                            {index !== 0 && <div className="divider" />}
                                            <span className="page-name">{getPathLabel(page)}</span>
                                        </>
                                    )}
                                </React.Fragment>
                            ))}
                        </S.PagesList>

                        {isHome && !useAllContracts ? (
                            <>
                                <span className="client-title">Cliente empresa</span>

                                <span className="active-contract-name">{dataActiveContract.nome}</span>
                            </>
                        ) : (
                            <span className="actual-page">{getPathLabel(lastPath)}</span>
                        )}
                    </>
                )}
            </S.BreadcrumbContainer>

            <ContractChange isHome={isHome} />
        </S.Container>
    );
}

export default Breadcrumb;
